import React from 'react';
import type { EpisodeEditImpactWarnings } from '../../utils/episodeEditImpact';

/**
 * Shared bullet list summarizing how an episode date edit affects existing
 * records. Used by both the episode editor and the visit-driven date sync
 * confirmation so the copy stays identical.
 */
export const EpisodeEditImpactList: React.FC<{
  warnings: EpisodeEditImpactWarnings;
}> = ({ warnings }) => (
  <ul className='list-disc space-y-1 pl-5 text-sm text-muted-foreground'>
    {warnings.visits_out_of_window > 0 && (
      <li>{warnings.visits_out_of_window} visit(s) outside the new window</li>
    )}
    {warnings.orders_out_of_window > 0 && (
      <li>{warnings.orders_out_of_window} order(s) outside the new window</li>
    )}
    {warnings.authorizations_out_of_window > 0 && (
      <li>
        {warnings.authorizations_out_of_window} authorization(s) outside the new
        window
      </li>
    )}
    {warnings.billing_cycles_to_void > 0 && (
      <li>
        {warnings.billing_cycles_to_void} open billing cycle(s) will be voided
      </li>
    )}
  </ul>
);

export default EpisodeEditImpactList;
